<template>
    <div>
        <div class="chain">
            <ui-chain-menu2 :data="steps" title="Criar novo Lançamento Imobiliário" @input="setSteps($event)" />
        </div>

        <div class="create">
            <div class="pages-route">
                <div v-if="next" class="load">
                    <ui-overlay-load background-color-overlay="rgba(212,208,208," />
                </div>
                <router-view :key="$route.fullPath" />
            </div>
        </div>
    </div>
</template>

<script>
	import { uiChainMenu2 } from '@/components/ui/menus'
	import { defaultMenuList, defaultForm } from './components/data'
	import { mapActions, mapGetters } from 'vuex'
    import { uiOverlayLoad } from '@/components/ui'

    export default {
		name: 'ui-launch-management-create',

        components: {
            uiChainMenu2,
			uiOverlayLoad
        },

        data() {
			return {
				menuList: [ ...defaultMenuList() ],
				load: false,
			}
		},

		computed: {
			...mapGetters('launchDay', {
				config: 'getConfig',
				steps: 'getSteps',
				next: 'getNextLoad'
			})
		},

		beforeMount() {
			if (!this.config) this.setConfig({ ...defaultForm() })
			if (!this.steps) this.setSteps([ ...defaultMenuList() ])
		},

		methods: {
			...mapActions('launchDay', ['setConfig', 'setSteps'])
		}
    }
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
